module.exports = {
    xxs: [
        '0.6875rem',
        {
            lineHeight: '1rem',
            letterSpacing: '0.3px',
        },
    ],
    xs: [
        '0.8125rem',
        {
            lineHeight: '1rem',
            letterSpacing: '0.3px',
        },
    ],

    sm: [
        '0.9375rem',
        {
            lineHeight: '1.375rem',
            letterSpacing: '0.25px',
        },
    ],
    base: [
        '1rem',
        {
            lineHeight: '1.5',
        },
    ],

    lg: [
        '1.125rem',
        {
            lineHeight: '1.375rem',
            letterSpacing: '0.25px',
        },
    ],

    xl: [
        '1.25rem',
        {
            lineHeight: '1.2',
            letterSpacing: '0.25px',
        },
    ],

    xxl: [
        '1.5rem',
        {
            lineHeight: '1.75rem',
            letterSpacing: '0.1px',
        },
    ],

    xxxl: [
        '1.6875rem',
        {
            lineHeight: '2rem',
            letterSpacing: '0.05px',
        },
    ],
}
